package one.healthium.today.ui.models

import one.healthium.domain.user.models.FoodItemModel
import one.healthium.domain.user.models.WaterLogModel
import one.healthium.tasks.domain.DailyTaskModel
import kotlin.time.Clock
import kotlin.time.Instant

data class DailyTaskUiModel(
    val model: DailyTaskModel,
    val typedPayload: DailyTaskTypedPayload?,
) {
    val name = model.info.name
    val type = model.type

    companion object {
        val previewLogWeight = DailyTaskUiModel(
            model = DailyTaskModel.previewLogWeight,
            typedPayload = DailyTaskTypedPayload.LogWeight(
                latestWeightLog = UpdateWeightUiModel(
                    currentWeight = 70f,
                    date = Clock.System.now(),
                    isMetric = true,
                ),
            ),
        )
        val previewLogWater = DailyTaskUiModel(
            model = DailyTaskModel.previewLogWater,
            typedPayload = DailyTaskTypedPayload.LogWater(null, null),
        )
    }
}

sealed interface DailyTaskTypedPayload {
    data class LogWater(val latestWaterLog: WaterLogModel?, val todayWaterIntake: WaterIntakeUiModel?) : DailyTaskTypedPayload
    data class LogWeight(val latestWeightLog: UpdateWeightUiModel?) : DailyTaskTypedPayload
    data class LogFood(val completed: Int, val overall: Int, val latestFoodLog: FoodItemModel?) : DailyTaskTypedPayload
    data class ReadInsight(val insightsCount: Int, val latestReadDate: Instant?) : DailyTaskTypedPayload
}
